const mockPlaceId = 'mock-place-id-123-main-st';

const mockAddressComponents = [
  { long_name: '123', short_name: '123', types: ['street_number'] },
  { long_name: 'Main Street', short_name: 'Main St', types: ['route'] },
  {
    long_name: 'Manhattan',
    short_name: 'Manhattan',
    types: ['sublocality_level_1', 'sublocality', 'political'],
  },
  {
    long_name: 'New York',
    short_name: 'New York',
    types: ['locality', 'political'],
  },
  {
    long_name: 'New York',
    short_name: 'NY',
    types: ['administrative_area_level_1', 'political'],
  },
  {
    long_name: 'United States',
    short_name: 'US',
    types: ['country', 'political'],
  },
  { long_name: '10001', short_name: '10001', types: ['postal_code'] },
];

const mockFormattedAddress = '123 Main St, New York, NY 10001, USA';

/** Wire format of Google Maps JS API `AutocompleteService.getPlacePredictions` */
export const mockPlacePredictions = {
  status: 'OK',
  predictions: [
    {
      description: mockFormattedAddress,
      place_id: mockPlaceId,
      reference: mockPlaceId,
      types: ['street_address', 'geocode'],
      matched_substrings: [{ length: 3, offset: 0 }],
      terms: [
        { offset: 0, value: '123 Main St' },
        { offset: 13, value: 'New York' },
        { offset: 23, value: 'NY' },
        { offset: 27, value: 'USA' },
      ],
      structured_formatting: {
        main_text: '123 Main St',
        main_text_matched_substrings: [{ length: 3, offset: 0 }],
        secondary_text: 'New York, NY, USA',
      },
    },
  ],
};

/** Wire format of Google Maps JS API `PlacesService.getDetails` */
export const mockPlaceDetails = {
  status: 'OK',
  html_attributions: [],
  result: {
    place_id: mockPlaceId,
    formatted_address: mockFormattedAddress,
    address_components: mockAddressComponents,
    geometry: { location: { lat: 40.7506, lng: -73.9972 } },
    types: ['street_address'],
  },
};

/** Wire format of Google Maps JS API `Geocoder.geocode` */
export const mockGeocodeResults = {
  status: 'OK',
  results: [
    {
      place_id: mockPlaceId,
      formatted_address: mockFormattedAddress,
      address_components: mockAddressComponents,
      geometry: {
        location: { lat: 40.7506, lng: -73.9972 },
        location_type: 'ROOFTOP',
        viewport: {
          north: 40.7519,
          south: 40.7493,
          east: -73.9959,
          west: -73.9985,
        },
      },
      types: ['street_address'],
    },
  ],
};
